import type { Comment, SocialProofItem } from "@/lib/api";

export type NativeCommentViewModel = {
  id?: string;
  text: string;
  author: string;
  displayHandle?: string;
  platform: string;
  sourceKind?: string;
  likeCount?: number;
  createdAt?: string;
  avatarUrl?: string | null;
  proofLabel?: string;
};

/** Canonical platform for skins / filenames (API sometimes sends FAC/INS/…). */
export function normalizeCommentPlatform(
  platform?: string | null,
  sourceKind?: string | null,
): string {
  const sk = String(sourceKind || "").toLowerCase();
  if (sk === "comment_ig" || sk === "dm_ig") return "instagram";
  if (sk === "comment_fb" || sk === "dm_fb") return "facebook";

  const raw = String(platform || "")
    .trim()
    .toLowerCase();
  if (!raw) return "instagram";
  if (raw === "ig" || raw === "ins" || raw.startsWith("insta")) return "instagram";
  if (raw === "fb" || raw === "fac" || raw.startsWith("face")) return "facebook";
  if (raw === "tt" || raw === "tik" || raw.startsWith("tiktok")) return "tiktok";
  if (raw === "yt" || raw === "you" || raw.startsWith("youtube")) return "youtube";
  if (raw === "instagram" || raw === "facebook" || raw === "tiktok" || raw === "youtube") {
    return raw;
  }
  return raw;
}

export function commentToNativeModel(c: Comment): NativeCommentViewModel {
  return {
    id: c.id,
    text: c.text,
    author: c.author,
    displayHandle: c.username || undefined,
    platform: normalizeCommentPlatform(c.platform || c.platform_id),
    likeCount: c.like_count,
    createdAt: c.created_at,
    avatarUrl: c.avatar_url,
  };
}

export function socialProofToNativeModel(item: SocialProofItem): NativeCommentViewModel {
  return {
    id: item.id,
    text: item.quote_anon || item.text,
    author: item.author,
    displayHandle: item.display_handle || undefined,
    platform: normalizeCommentPlatform(item.platform, item.source_kind),
    sourceKind: item.source_kind,
    likeCount: item.like_count,
    createdAt: item.created_at,
    avatarUrl: item.avatar_url,
    proofLabel: item.proof_label,
  };
}
